import React, { Component } from "react";
import { render } from 'react-dom'

import { Dropdown, Icon, Input, Menu, Button, Image, Header, Segment, Grid, Divider, Label } from 'semantic-ui-react'
import _ from "lodash"
import client from "../../../clientService";

import "./StoriesPreview.css";

import PlayerContext from "../../../playerContext";
import Draggable from "react-draggable";
import Swiper from 'react-id-swiper';

class StoriesPreview extends Component {
    static contextType = PlayerContext

    constructor(props) {
        super(props)

        this.state = {
            stories: []
        }
    }

    componentDidMount = () => {
        client.service("story").find({
            query: {
                "status": "completed",
                $sort: {
                    createdAt: -1
                }
            }
        })
            .then(resp => {
                console.log(resp.data);
                this.setState((state) => ({
                    stories: resp.data
                }));
            })
    }

    render() {
        const playerStatus = this.context

        return (
            // <Draggable >
                <div
                style={{
                    height:"250px"
                }}
                    // style={{
                    //     "zIndex": "9999",
                    //     "position": "absolute",

                    //     "top": "20vh",
                    //     "right": "5vw",
                    // }}
                >
                    <Label as='a' color='red' ribbon style={{ "left": 0 }}>
                        Drag me
                </Label>
                    <Swiper {...{
                        shouldSwiperUpdate: true,
                        slidesPerView: 'auto',
                        centeredSlides: true,
                        spaceBetween: 30,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        }
                    }}>
                        {
                            this.state.stories && this.state.stories.map(
                                story =>
                                    <div key={story._id}>
                                        {story.youtubelink}
                                    </div>
                            )
                        }
                    </Swiper>
                </div>
            // </Draggable >
        )
    }
}

export default StoriesPreview